import React from "react";
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from "chart.js";
import {Doughnut} from "react-chartjs-2";
import PropTypes from "prop-types";

ChartJS.register(ArcElement, Tooltip, Legend);

const downloadTypeNames = {
  re: "Trasera",
  la: "Lateral",
  de: "Doble gancho",
  ea: "Fácil",
  fr: "Frontal",
  ot: "Otro",
};

const getDownloadTypeName = (key) => downloadTypeNames[key] || "Desconocido";

const DownloadTypes = ({data}) => {
  if (!data) {
    return (
      <div className="card">
        <div className="card-header">
          <h5 className="m-0">Tipos de Descarga</h5>
        </div>
        <div className="card-body">
          <div className="text-center">Cargando datos...</div>
        </div>
      </div>
    );
  }

  const {title, downloads} = data;

  const keys = Object.keys(downloads);
  const labels = keys.map((key) => getDownloadTypeName(key));
  const values = Object.values(downloads);
  const total = values.reduce((sum, value) => sum + value, 0);

  // Generar colores con transparencia variable
  const baseColor = "#00a6de"; // Color azul base
  const transparency = {
    value: 40,
    sum: Math.trunc((255 - 40) / labels.length),
  };

  const backgroundColors = labels.map(() => {
    const hexTransparency = transparency.value.toString(16).padStart(2, "0");
    const color = `${baseColor}${hexTransparency}`;
    transparency.value += transparency.sum;
    return color;
  });

  // Crear los datos del gráfico
  const chartData = {
    labels: labels,
    datasets: [
      {
        label: "Tipos de Descarga",
        data: values,
        backgroundColor: backgroundColors,
        hoverOffset: 10,
      },
    ],
  };

  // Configurar opciones del gráfico
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "rect",
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: title || "Tipos de Descarga",
        font: {
          size: 16,
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const value = tooltipItem.raw;
            const percentage = ((value / total) * 100).toFixed(2);
            return `${tooltipItem.label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
  };

  return (
    <div className="mb-4">
      <div className="border pb-3" style={{height: "320px"}}>
        <Doughnut data={chartData} options={chartOptions} />
      </div>
    </div>
  );
};

export default DownloadTypes;
